module.exports = __webpack_public_path__ + "static/Isha_Front_Big-924ec8c2095b9b315f0ba062e8532766.png";